export const Features = (props) => {
  return (
    <div id='features' className='text-center'>
      <div className='container'>
        <div >
        <hr/>
          <h3 className='carac'>Nuestras Características</h3>
          <hr/>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className='col-xs-6 col-md-3'>
                  {' '}
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : 'Cargando..'}
        </div>
      </div>
    </div>
  )
}
